import React, { useCallback } from "react";
import { School } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { StateBadge } from "./AdminLayout";
import { apiGet, apiPost, apiPut } from "./adminApi";

const loadInstitutions = async () => {
  const list = await apiGet("hec/hli/getAllHli");
  return list.map((i) => ({ value: i.id, label: i.institutionCode ? `${i.fullName} (${i.institutionCode})` : i.fullName }));
};

const fields = [
  { name: "institutionId", label: "Institution", type: "select", required: true, optionsKey: "institutions", optionsLoader: loadInstitutions, fullWidth: true },
  { name: "collegeCode", label: "College Code", type: "text", placeholder: "e.g. CST" },
  { name: "collegeShorName", label: "Short Name", type: "text", placeholder: "e.g. UR-CST" },
  { name: "collegeName", label: "College Name", type: "text", required: true, placeholder: "e.g. College of Science and Technology", fullWidth: true },
  { name: "studyField", label: "Study Field", type: "text", placeholder: "e.g. Science" },
  { name: "brdCode", label: "BRD Code", type: "text", placeholder: "Code used by BRD" },
  { name: "active", label: "Status", type: "checkbox", checkboxLabel: "College is active", editOnly: true, fullWidth: true },
];

export default function CollegesPage() {
  const toFormValues = useCallback(
    (row) => ({ ...row, institutionId: row.institution?.id || "", active: row.state === 1 }),
    []
  );
  return (
    <AdminCrudPage
      title="Colleges"
      subtitle="Colleges / schools within each higher learning institution"
      icon={School}
      entityName="college"
      queryKey="adminColleges"
      fetchAll={() => apiGet("hec/college/admin/all")}
      createItem={({ active, ...values }) => apiPost("hec/college/admin/create", values)}
      updateItem={(id, { active, ...values }) => apiPut(`hec/college/admin/${id}`, { ...values, state: active ? 1 : 0 })}
      searchKeys={["collegeCode", "collegeName", "collegeShorName", "studyField", "brdCode", "institution.fullName"]}
      columns={[
        { key: "collegeCode", label: "Code", render: (r) => <span className="font-mono text-gray-700">{r.collegeCode || "—"}</span> },
        { key: "collegeName", label: "College", render: (r) => (
            <div>
              <div className="font-semibold text-gray-900">{r.collegeName}</div>
              {r.collegeShorName && <div className="text-xs text-gray-400">{r.collegeShorName}</div>}
            </div>
          ) },
        { key: "institution.fullName", label: "Institution" },
        { key: "studyField", label: "Study Field" },
        { key: "brdCode", label: "BRD Code" },
        { key: "state", label: "Status", render: (r) => <StateBadge state={r.state} /> },
      ]}
      fields={fields}
      toFormValues={toFormValues}
      filters={[
        { name: "institution", label: "Institutions", optionsLoader: loadInstitutions, match: (row, v) => row.institution?.id === v },
      ]}
      emptyHint="Add colleges under their institution so campuses can be attached to them."
    />
  );
}
